/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSkateboard = createReactComponent("skateboard", "IconSkateboard", [
  ["path", { d: "M7 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  ["path", { d: "M17 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-1" }],
  ["path", { d: "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1", key: "svg-2" }]
]);

export { IconSkateboard as default };
//# sourceMappingURL=IconSkateboard.js.map
